import React from "react";

export default function EmptyPicks({ message = "No predictions yet. The model posts daily — check back shortly.", generating = false }) {
    return (
        <div
            className="border border-dashed border-border p-10 text-center bg-card/40"
            data-testid="empty-picks-state"
        >
            <div className="font-mono text-xs uppercase tracking-[0.3em] text-zinc-500 mb-2">
                {generating ? "▌ MODEL IS COOKING — REFRESH IN A FEW SECONDS" : "▌ NOTHING TO SHOW"}
            </div>
            <p className="text-sm text-zinc-400 max-w-md mx-auto">{message}</p>
        </div>
    );
}
